import { Transition } from "motion";

export const notificationVariants = {
  initial: { opacity: 0, y: 100 },
  in: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 100 },
};

export const notificationTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 1,
};

